const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const padNumber = (n, padLength) => String(n).padStart(padLength, '0');
const getSaleEndTimeString = (saleEndDate, geo) => {
  if (geo === 'US' || geo === 'CA') {
    return '(11:59 PM PT)';
  }
  const date = new Date(saleEndDate);
  const hrsString = padNumber(date.getUTCHours(), 2);
  const minString = padNumber(date.getUTCMinutes(), 2);
  return `(${hrsString}:${minString} GMT)`;
};
export const formatSaleEndDate = _ref => {
  let {
    saleEndDate,
    geo,
    formatter
  } = _ref;
  const hourAndTimezone = getSaleEndTimeString(saleEndDate, geo);
  if (geo === 'US' || geo === 'CA') {
    return formatter(saleEndDate - ONE_DAY_MS).concat(' ', hourAndTimezone);
  }
  return formatter(saleEndDate).concat(' ', hourAndTimezone);
};
//# sourceMappingURL=formatSaleEndDate.js.map